import { type FC } from 'react'
import CourseTable from './CourseTable'
import { usePastCoursesQuery } from './query'

const PastCourseList: FC = () => {
  const { data, isLoading } = usePastCoursesQuery()

  return <CourseTable datasource={data} isLoading={isLoading} />
}

export default PastCourseList
